import { AppThunk } from 'store';
import { batch } from 'react-redux';
import dataSources from 'dataSources';
import setAuthData from 'common/utils/auth/setAuthData';
import { USER_TYPES } from 'common/utils/userTypes';
import parseAuthData from 'common/utils/auth/parseAuthData';
import resetAuthData from 'common/utils/auth/resetAuthData';
import { deleteCountRefreshPage } from 'common/utils/auth/countRefresgPage';
import { getResponseError } from 'common/utils/index';
import { STATUS_LOADING } from 'common/constants/statusLoading';

import slice from '../reducer/slice';
import appSlice from '../../application/reducer/slice';

const { setUserType, setUser, setUserLoadingStatus } = slice.actions;
const { setError } = appSlice.actions;

type TOperation = (identifyToken: string, clientId?: string) => AppThunk;

const operation: TOperation = (identifyToken, clientId) => async (dispatch) => {
  try {
    dispatch(setUserLoadingStatus(STATUS_LOADING.load));
    deleteCountRefreshPage();

    const { data } = await dataSources.auth.getAuthTokensByIdentityToken(
      identifyToken,
      clientId,
    );

    const authData = parseAuthData(data);
    await setAuthData({ ...authData, isIdentifyToken: true });

    batch(() => {
      dispatch(setUserLoadingStatus(STATUS_LOADING.done));
      dispatch(setUser(authData));
      dispatch(setUserType(USER_TYPES.autorized));
    });
  } catch (e) {
    const error = await getResponseError(e);
    batch(() => {
      dispatch(setError(error));
      resetAuthData();
      dispatch(setUserLoadingStatus(STATUS_LOADING.error));
      dispatch(setUserType(USER_TYPES.unautorized));
    });
  }
};

export default operation;
